export const searchCopy = {
  fr: {
    placeholder: 'Rechercher une page, une action...',
    empty: 'Aucun resultat.',
    shortcut: 'Ctrl K',
    suggestedRoutes: 'Pages correspondantes',
    openSearch: 'Rechercher',
    didYouKnow: 'Ctrl K ouvre une recherche globale pour trouver n\'importe quelle page.',
  },
  en: {
    placeholder: 'Search a page, action...',
    empty: 'No results.',
    shortcut: 'Ctrl K',
    suggestedRoutes: 'Matching pages',
    openSearch: 'Search',
    didYouKnow: 'Ctrl K opens a global search to find any page.',
  },
} as const;

export type SearchCopyKey = keyof typeof searchCopy.fr;
